"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Gym;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Gym(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "gym"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M85.116,47.5H81.5V40.258a2.5,2.5,0,0,0-5,0v-5a2.5,2.5,0,0,0-5,0V30.884a2.5,2.5,0,0,0-5,0V47.5h-33V30.884a2.5,2.5,0,0,0-5,0v4.374a2.5,2.5,0,0,0-5,0v5a2.5,2.5,0,0,0-5,0V47.5H14.884a2.5,2.5,0,0,0,0,5H18.5v7.242a2.5,2.5,0,0,0,5,0v5a2.5,2.5,0,0,0,5,0v4.374a2.5,2.5,0,0,0,5,0V52.5h33V69.116a2.5,2.5,0,0,0,5,0V64.742a2.5,2.5,0,1,0,5,0v-5a2.5,2.5,0,0,0,5,0V52.5h3.616a2.5,2.5,0,0,0,0-5Z"
  }))));
}